import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { borderRadius } from '@infl-ts/ui-advocate-theme';
import { Box, styled } from '@mui/material';
export var DrawerPuller = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 40;\n  height: 4;\n  background-color: ", ";\n  border-radius: ", ";\n  margin: 'auto';\n  margin-top: 4px;\n  margin-bottom: 8px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.action.focus;
}, function (_ref2) {
  var theme = _ref2.theme;
  return borderRadius(theme);
});